import React from "react";
import Settings from "./Settings";
import Heading from "../../components/Heading";
import "./styles.scss";
function index() {
  return (
    <>
      <div className="p-1">
        <div className="mb-1">
          <Heading title={"Settings"} disableBackButton={true} />
        </div>
        <Settings />
      </div>
    </>
  );
}

export default index;
